import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { CSSTransition } from "react-transition-group";
import { goToAuthPanel, openModal } from "../../redux/Slice/modalSlice";
import { modalState } from "../../utils/constants";
// components
import InfoTrack from "../SideMenu/InfoTrack/InfoTrack";
import Modal from "../Modal";
import AuthModal from "../Auth/AuthModal";
import ConfirmExitModal from "../ConfirmExitModal/ConfirmExitModal";
// assets
import Logo from "./assets/logo.svg";
import {
  AuthBtn,
  BlackPageForSideMenu,
  HeaderContainer,
  HeaderLogoImg,
  MenuWrapper,
  MenuLink,
  CloseMenuButton,
  OpenMenuButton,
} from "./styled";
import { authSelector } from "../../redux/selectors/authSelector";
import ReleaseTextModal from "../ReleaseTextModal";
import IconButton from "../IconButton";
import ReleasePodcastInfo from "../SideMenu/ReleasePodcastInfo/ReleasePodcastInfo";

export const CSS_TRANSITION_TIMEOUT = 300;

const Header = () => {
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const { isAuth } = useSelector(authSelector);
  const blackout = useSelector((state) => state.modalSlice.blackout);
  const modalOpen = useSelector((state) => state.modalSlice.activeModals);
  const blackoutZIndex = useSelector(
    (state) => state.modalSlice.blackoutZIndex,
  );

  const [showMenu, setShowMenu] = useState(false);

  return (
    <HeaderContainer>
      <Link to="/">
        <HeaderLogoImg src={Logo} alt="IT-Radio" />
      </Link>
      <MenuWrapper showMenu={showMenu}>
        {showMenu && (
          <IconButton as={CloseMenuButton} onClick={() => setShowMenu(false)}>
            <img src="/cross.svg" alt="Закрыть" />
          </IconButton>
        )}
        <MenuLink
          onClick={() => setShowMenu(false)}
          to="/"
          active={pathname === "/" ? "true" : undefined}
        >
          [Главная]
        </MenuLink>
        <MenuLink
          onClick={() => setShowMenu(false)}
          to="/podcasts"
          active={pathname === "/podcasts" ? "true" : undefined}
        >
          [Подкасты]
        </MenuLink>

        {isAuth && (
          <MenuLink
            onClick={() => setShowMenu(false)}
            to="/favorite"
            active={pathname === "/favorite" ? "true" : undefined}
          >
            [Избранное]
          </MenuLink>
        )}
        <MenuLink
          onClick={() => setShowMenu(false)}
          to="/contacts"
          active={pathname === "/contacts" ? "true" : undefined}
        >
          [Контакты]
        </MenuLink>
        {!isAuth ? (
          <AuthBtn onClick={() => dispatch(goToAuthPanel(modalState.AUTH))}>
            [Вход и регистрация]
          </AuthBtn>
        ) : (
          <AuthBtn onClick={() => dispatch(openModal(modalState.CONFIRM_EXIT))}>
            [Выйти]
          </AuthBtn>
        )}
      </MenuWrapper>
      <IconButton as={OpenMenuButton} onClick={() => setShowMenu(true)}>
        <img src="/burger-menu.svg" alt="Открыть меню" />
      </IconButton>
      {!modalOpen.includes("releaseText") && (
        <CSSTransition
          in={blackout}
          timeout={100}
          classNames="blackPageForSide"
          unmountOnExit
        >
          <BlackPageForSideMenu modalOpen={modalOpen} zIndex={blackoutZIndex} />
        </CSSTransition>
      )}
      <Modal
        modal={modalState.RELEASE_TEXT}
        openingDirection="fullWidth"
        backgroundColor="var(--background-primary)"
        zIndex={97}
      >
        <ReleaseTextModal />
      </Modal>
      <Modal
        modal={modalState.TRACK_INFO}
        openingDirection="onRight"
        title="О треке"
      >
        <InfoTrack />
      </Modal>
      <Modal
        modal={modalState.RELEASE_PODCAST_INFO}
        openingDirection="onRight"
        title="О выпуске"
      >
        <ReleasePodcastInfo />
      </Modal>
      <AuthModal />
      <ConfirmExitModal />
    </HeaderContainer>
  );
};

export default Header;
